import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTORS_QUERY_KEYS } from "Actors/Api/Queries/queryKeys";
import { deleteUsersUserIDProfilePicture } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

export function useDeleteActorProfilePictureMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (userID: string) => deleteUsersUserIDProfilePicture(userID),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.DeleteUserProfilePicture,
        ),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.all,
        exact: false,
      });
    },
  });
}
